import React from 'react';
import qs from 'querystringify';
import { useStoreState } from 'easy-peasy';
import { toast } from 'react-toastify';

import Layout from '../../../components/global/Layout';
import { Pagination } from '../../../components/elements';
import Header from './Header';
import Search from './Search';
import BookingTransactions from './BookingTransactions';
import {
  useTableBookingDashboardCSVData,
  useTableBookingDashboardData,
} from './helpers';
import { downloadCSVFile } from '../../OrderManagement/OrderTransactions/helpers';

const setStartDateHours = dateObject => {
  dateObject.setHours(0, 0, 0, 0);
  return dateObject;
};

const setEndDateHours = dateObject => {
  dateObject.setHours(23, 59, 59, 999);
  return dateObject;
};

const startDateISOString = () => {
  const startDate = setStartDateHours(new Date());
  // startDate.setDate(startDate.getDate() - 90);
  return startDate.toISOString();
};

const endDateISOString = () => {
  const endDate = setEndDateHours(new Date());
  return endDate.toISOString();
};

const LIST_SIZE = 50;

const TableBookingTransactions = ({ history, location }) => {
  const { userId: adminUserId } = useStoreState(state => state.auth);

  const routeState = qs.parse(location.search);

  const [downloadCsv, setDownloadCsv] = React.useState(false);

  const [startDateFilterRef, setStartDateRef] = React.useState();
  const [endDateFilterRef, setEndDateRef] = React.useState();

  const { page, placeFilter, cityFilter } = routeState;

  let { dateFilterDisabled } = routeState;

  if (dateFilterDisabled) {
    dateFilterDisabled = dateFilterDisabled === 'true';
  } else {
    dateFilterDisabled = true;
  }

  let startDateFilter;
  let endDateFilter;

  if (startDateFilterRef) {
    startDateFilter = new Date(startDateFilterRef).toISOString();
  } else {
    startDateFilter = startDateISOString();
  }

  if (endDateFilterRef) {
    endDateFilter = new Date(endDateFilterRef).toISOString();
  } else {
    endDateFilter = endDateISOString();
  }

  const currentPage = parseInt(page, 10) - 1 >= 0 ? parseInt(page, 10) - 1 : 0;

  const handleChange = args => {
    history.push(
      `/table-booking-transactions${qs.stringify(
        {
          ...routeState,
          page: 1,
          ...args,
        },
        true,
      )}`,
    );
  };

  const [
    loadingTableBookingDashboardData,
    tableBookingDashboardData,
    totalSizeTableBookingDashboardData,
    totalPagesTableBookingDashboardData,
  ] = useTableBookingDashboardData({
    adminUserId,
    from: currentPage * LIST_SIZE,
    size: LIST_SIZE,
    city: cityFilter,
    placeId: placeFilter,
    startDate: startDateFilter,
    endDate: endDateFilter,
    dateFilterDisabled,
  });

  const [
    loadingTableBookingDashboardCSVData,
    tableBookingDashboardCSVData,
  ] = useTableBookingDashboardCSVData({
    adminUserId,
    from: currentPage * LIST_SIZE,
    size: LIST_SIZE,
    city: cityFilter,
    placeId: placeFilter,
    startDate: startDateFilter,
    endDate: endDateFilter,
    dateFilterDisabled,
  });

  const onDownloadCSV = content => {
    try {
      setDownloadCsv(true);
      downloadCSVFile(
        content,
        `booking-fee-dashboard-${new Date().toISOString()}.csv`,
      );
    } catch (error) {
      toast.error(
        `Failed to download CSV: ${error.message || 'Unknown error'}`,
      );
    } finally {
      setDownloadCsv(false);
    }
  };

  return (
    <Layout>
      <Header />
      <Search
        bookingDateFilter={null}
        placeName={placeFilter}
        city={cityFilter}
        handleChange={handleChange}
        dateFilterDisabled={dateFilterDisabled}
        setStartDateRef={setStartDateRef}
        setEndDateRef={setEndDateRef}
      />
      {!loadingTableBookingDashboardCSVData && (
        <button
          className={`${downloadCsv &&
            'is-loading'} button is-primary is-outlined`}
          style={{ margin: '5px' }}
          onClick={async () => {
            onDownloadCSV(tableBookingDashboardCSVData?.contentCSV);
          }}
        >
          Download CSV
        </button>
      )}

      {totalSizeTableBookingDashboardData > 0 && (
        <Pagination
          pageFrom={currentPage * LIST_SIZE}
          pageCount={totalPagesTableBookingDashboardData}
          listSize={LIST_SIZE}
          totalElements={totalSizeTableBookingDashboardData}
          currentPage={currentPage}
          handlePageClick={value => {
            history.push(
              `/table-booking-transactions${qs.stringify(
                {
                  ...routeState,
                  page: value.selected + 1,
                },
                true,
              )}`,
            );
          }}
        />
      )}
      <BookingTransactions
        loading={loadingTableBookingDashboardData}
        transactionData={tableBookingDashboardData}
        history={history}
      />
    </Layout>
  );
};

export default TableBookingTransactions;
